'use es6';

import * as DSAssetFamilies from 'customer-data-filters/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import * as ListSegConstants from 'customer-data-filters/converters/listSegClassic/ListSegConstants';
import { CtaHasClicked, CtaHasNotClicked, CtaHasNotSeen, CtaHasSeen } from './operator/Operators';
import { List, Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { testDynamicFilterFamily } from '../filterQueryFormat/DynamicFilterFamilies';
import And from './logic/And';
import FilterOperatorDescription from './FilterOperatorDescription';
import Or from './logic/Or';
export const getFilterDescription = (filterQuery, filterFamily) => {
  if (Or.isOr(filterQuery) || And.isAnd(filterQuery)) {
    return filterQuery.get('conditions').reduce((acc, query) => {
      const description = getFilterDescription(query, filterQuery.get('filterFamily'));
      if (List.isList(description)) {
        return acc.concat(description);
      }
      return acc.push(description);
    }, List());
  }
  return FilterOperatorDescription({
    filterFamily,
    operator: filterQuery
  });
};

// Gets all leaf node conditions and bundles them with the filter family of the
// containing logic group. Return Type: [{filterQuery, filterFamily}, ...]
const getLeafNodeConditionsWithFilterFamily = (filterQuery, filterFamily) => {
  if (!Or.isOr(filterQuery) && !And.isAnd(filterQuery)) {
    return [{
      filterQuery,
      filterFamily
    }];
  }
  return filterQuery.get('conditions').reduce((acc, query) => {
    const conditionsWithFilterFamilies = getLeafNodeConditionsWithFilterFamily(query, filterQuery.get('filterFamily'));
    acc.push(...conditionsWithFilterFamilies);
    return acc;
  }, []);
};
const noMappingHelper = () => [];
const ignoreValues = {
  [DSAssetFamilies.CONTACT_PROPERTY]: ListSegConstants.__PRIVACY_CONSENT,
  [DSAssetFamilies.FORM]: ListSegConstants.__ANY_FORM,
  [DSAssetFamilies.GOTO_WEBINAR_WEBINAR]: ListSegConstants.__ANY_WEBINAR
};
const defaultMappingHelper = ({
  field: {
    name: value
  }
}, filterFamily) => {
  return ignoreValues[filterFamily] === value ? [] : [filterFamily, value];
};
const ctaMappingHelper = filterQuery => {
  const operatorUsesPlacementFamily = filterQuery instanceof CtaHasNotClicked || filterQuery instanceof CtaHasNotSeen || filterQuery instanceof CtaHasSeen || filterQuery instanceof CtaHasClicked;
  if (!operatorUsesPlacementFamily) {
    return [];
  }
  return filterQuery.value === ListSegConstants.__ANY_CTA ? [DSAssetFamilies.CTA, filterQuery.field.name] : [DSAssetFamilies.CTA_TO_PLACEMENT, filterQuery.value];
};

// Must return an empty array [] or a mapping in the form [key, value]
const filterFamilyMappingHelpers = {
  [DSAssetFamilies.CTA]: ctaMappingHelper,
  [DSAssetFamilies.PAGE_VIEW]: noMappingHelper,
  [DSAssetFamilies.EMAIL_SUBSCRIPTION]: noMappingHelper,
  [DSAssetFamilies.FORM]: defaultMappingHelper,
  [DSAssetFamilies.GOTO_WEBINAR_WEBINAR]: defaultMappingHelper,
  [DSAssetFamilies.EVENT]: defaultMappingHelper,
  DEFAULT: defaultMappingHelper
};
const getMappingForCondition = ({
  filterQuery,
  filterFamily
}) => {
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, filterFamily)) {
    return [DSAssetFamilies.INTEGRATION, filterFamily];
  }
  return Object.prototype.hasOwnProperty.call(filterFamilyMappingHelpers, filterFamily) ? filterFamilyMappingHelpers[filterFamily](filterQuery, filterFamily) : filterFamilyMappingHelpers.DEFAULT(filterQuery, filterFamily);
};

// Returns a Map of Sets of field names keyed by filterFamilies
export const getUniqueFieldIdsByAssetFamily = filterQuery => {
  return getLeafNodeConditionsWithFilterFamily(filterQuery).reduce((acc, conditionWithFamily) => {
    const [key, value] = getMappingForCondition(conditionWithFamily);
    if (key) {
      const set = acc.has(key) ? acc.get(key).add(`${value}`) : ImmutableSet.of(`${value}`);
      return acc.set(key, set);
    }
    return acc;
  }, ImmutableMap());
};
export const getFilterFamilies = filterQuery => {
  return getLeafNodeConditionsWithFilterFamily(filterQuery).reduce((acc, {
    filterFamily
  }) => acc.add(filterFamily), ImmutableSet()).toList();
};